import { render, staticRenderFns } from "./ImageContent.vue?vue&type=template&id=d8f947d4&"
import script from "./ImageContent.vue?vue&type=script&lang=js&"
export * from "./ImageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports